module.exports = __webpack_public_path__ + "img/hotSale.f3578d40.png";